export enum DeclineRiskDecisionCode {
  PERSONAL_PAYMENT = 14,
  PREPAYMENT = 40,
  OFAC_BLOCK = 64,
  OFAC_REJECT = 65
}

export enum PendingRiskDecisionCode {
  ESCALATED_INTERNALLY = 29,
  RFI = 55
}

export const RISK_DECISION_CODES = {
  FORBIDDEN_AR_DECLINE_REASONS: [DeclineRiskDecisionCode.PERSONAL_PAYMENT],
  FORBIDDEN_PENDING_REASONS: [
    PendingRiskDecisionCode.ESCALATED_INTERNALLY,
    PendingRiskDecisionCode.RFI
  ],
  FORBIDDEN_DECLINE_REASONS: [
    DeclineRiskDecisionCode.PREPAYMENT,
    DeclineRiskDecisionCode.OFAC_BLOCK,
    DeclineRiskDecisionCode.OFAC_REJECT
  ]
};
